const CheckInterval = 5000;

type ResumeHandler = () => void;

const resumeHandler: ResumeHandler[] = [];

export function installDeviceResumeDetection() {
	let lastTime = new Date().getTime();

	const check = () => {
		const currentTime = new Date().getTime();
		if (currentTime > (lastTime + CheckInterval * 2)) { // ignore small delays
			console.log("Device resumed.");
			for (let handler of resumeHandler) {
				try {
					handler();
				}
				catch (error) {
					console.error("Error thrown from resume handler", error);
				}
			}
		}
		lastTime = currentTime;
		setTimeout(check, CheckInterval);
	};

	setTimeout(check, CheckInterval);
}

export function addResumeHandler(handler: ResumeHandler) {
	resumeHandler.push(handler);
}
